export enum EventTypes {
  Enter = 'Enter',
  KeyPress = 'keyPress',
  Blur = 'blur',
}
